
<div  class="row" >
  <div class="col-12">
    <div class="froala-headline-editor">
      <!-- Any tag modification will change how froala data is saved. See saveWithHtml method -->
      <InlineEditor
        class="froala-editor"
        :config="config"
        :content="content"
        @change="(value) => selectAction(value)"/>
    </div>
  </div>
</div>
